var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6937 5.53977C12.5995 5.53977 13.3337 4.80551 13.3337 3.89977C13.3337 2.99402 12.5995 2.25977 11.6937 2.25977C10.788 2.25977 10.0537 2.99402 10.0537 3.89977C10.0537 4.80551 10.788 5.53977 11.6937 5.53977Z",
    stroke: "#B6B6B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.307 5.53977C5.21274 5.53977 5.94699 4.80551 5.94699 3.89977C5.94699 2.99402 5.21274 2.25977 4.307 2.25977C3.40125 2.25977 2.66699 2.99402 2.66699 3.89977C2.66699 4.80551 3.40125 5.53977 4.307 5.53977Z",
    stroke: "#B6B6B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6937 13.74C12.5995 13.74 13.3337 13.0057 13.3337 12.1C13.3337 11.1942 12.5995 10.46 11.6937 10.46C10.788 10.46 10.0537 11.1942 10.0537 12.1C10.0537 13.0057 10.788 13.74 11.6937 13.74Z",
    stroke: "#B6B6B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.307 13.74C5.21274 13.74 5.94699 13.0057 5.94699 12.1C5.94699 11.1942 5.21274 10.46 4.307 10.46C3.40125 10.46 2.66699 11.1942 2.66699 12.1C2.66699 13.0057 3.40125 13.74 4.307 13.74Z",
    stroke: "#B6B6B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.97ad8789cd03286d8287e77fd882b302.svg";
export { ForwardRef as ReactComponent };